"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceRecordingFormatEnum = void 0;
var VoiceRecordingFormatEnum;
(function (VoiceRecordingFormatEnum) {
    VoiceRecordingFormatEnum["WAV"] = "wav";
    VoiceRecordingFormatEnum["WAV49"] = "wav49";
    VoiceRecordingFormatEnum["GSM"] = "gsm";
})(VoiceRecordingFormatEnum = exports.VoiceRecordingFormatEnum || (exports.VoiceRecordingFormatEnum = {}));
